import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl';
import './index.css'
export default class NoData extends Component {
  render() {
    return (
      <div className="noActivityTip">
                <p><FormattedMessage id="intl-ComingSoon"/></p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/NoData/index.jsx